/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { ReactComponent as IconExcel } from 'assets/images/Excel_.svg';
import './ExcelButton.css';

function ExcelButton(props) {
  // eslint-disable-next-line react/prop-types
  const { children, type, disabled, ...restProps } = props;
  return (
    <Button
      className="btn-excel"
      type={type}
      disabled={disabled}
      {...restProps}
      icon={
        <IconExcel
          className="icon-excel"
          style={{ color: '#c12b7d', width: '100%', height: '100%' }}
        />
      }
    />
  );
}

ExcelButton.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool
};

ExcelButton.defaultProps = {
  type: 'text',
  disabled: false
};

export default ExcelButton;
